<template>
  <p class="subheading ">
    <slot/>

    <v-container>
      <v-layout wrap row align-center justify-center>
        <v-flex class="technologies-item--block ma-2" v-for="item in items" :key="item.name"
                text-xs-center>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on"><img :src="getImgUrl(`logos/${item.image}`)" :alt="item.name" :title="item.name"/></span>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>

  </p>
</template>

<script>
export default {
  name: 'TechView',
  props: {
    items: Array,
  },
  methods: {
    getImgUrl(img) {
      // eslint-disable-next-line
      return require(`@/assets/${img}`);
    },
  },
};
</script>

<style scoped>
  .technologies-item--block {
    flex: 0 0 auto;
  }

  .technologies-item--block img {
    max-width: 120px;
    max-height: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TechView.vue